import {memo} from 'react';

import {equals, isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {DashboardTile} from '../../../types/DashboardTile';

interface DashboardTileContentProps {
  tile: DashboardTile | Nullish;
}

// `renderer.render` is a fresh closure every render; `renderer.props` is what it closes over.
const areTilesEqual = (previous: DashboardTileContentProps, next: DashboardTileContentProps) =>
  previous.tile?.id === next.tile?.id &&
  previous.tile?.size === next.tile?.size &&
  equals(previous.tile?.renderer.props, next.tile?.renderer.props);

export const DashboardTileContent = memo(function DashboardTileContent(
  props: DashboardTileContentProps
) {
  if (isNil(props.tile)) {
    return null;
  }

  return <>{props.tile.renderer.render(props.tile.size)}</>;
}, areTilesEqual);
